export enum SessionListType {
  Site = 'site',
  Client = 'client',
  Spot = 'spot',
  Case = 'case',
}

export const sessionListTypeId = {
  [SessionListType.Site]: 0,
  [SessionListType.Client]: 1,
  [SessionListType.Case]: 2,
  [SessionListType.Spot]: 3,
};
